export default "__VITE_ASSET__DfAx1kMz__"